import { BigNum } from '@drift-labs/sdk';
import { UIMarket, UISerializableFundingPaymentRecord } from '@drift/common';

export interface FundingHistoryData extends UISerializableFundingPaymentRecord {
	market: string;
	size: BigNum;
	datetime: number;
	rate: BigNum;
	accountName: string;
}

export const fundingHistorySelector = (
	fundingPayments: UISerializableFundingPaymentRecord[],
	accountName: string
): FundingHistoryData[] => {
	let result: FundingHistoryData[] = [];
	result =
		fundingPayments.map((fundingPayment) => {
			let rate = BigNum.zero();

			if (fundingPayment.baseAssetAmount.gt(BigNum.zero())) {
				rate = fundingPayment.ammCumulativeFundingLong
					.sub(fundingPayment.userLastCumulativeFunding)
					.neg();
			} else {
				rate = fundingPayment.ammCumulativeFundingShort.sub(
					fundingPayment.userLastCumulativeFunding
				);
			}

			return {
				market:
					UIMarket.perpMarkets[fundingPayment.marketIndex].baseAssetSymbol,
				size: fundingPayment.fundingPayment,
				datetime: fundingPayment.ts.toNumber() * 1000,
				rate,
				accountName: accountName,
				...fundingPayment,
			};
		}) ?? [];

	return result;
};
